import { Navigate } from "react-router-dom";
import HomeBuilder from "./cms/HomeBuilder";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import PortfolioDetail from "./pages/PortfolioDetail";
import Works from "./pages/Works";
import TeamDetail from "./pages/TeamDetail";
import { NotFoundPage } from "./cms/NotFoundPage";
import Home from "./pages/Home";
import NutritionCoaching from "./pages/NutritionCoaching";
import BlogPage from "./pages/Blog/BlogPage";
import BlogPostPage from "./pages/Blog/BlogPostPage";

export const routes = [
  {
    path: "/podcast",
    element: <Navigate to="https://2020.andycary.com/podcast/" replace />
  },
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/software-engineer",
    element: <HomeBuilder />
  },
  {
    path: "/nutrition-coaching",
    element: <NutritionCoaching />
  },
  {
    path: "/contact",
    element: <Contact />
  },
  {
    path: "/services",
    element: <Services />
  },
  {
    path: "/portfolio",
    element: <Works />
  },
  {
    path: "/portfolio/:id",
    element: <PortfolioDetail />
  },
  {
    path: "/about",
    element: <TeamDetail />
  },
  {
    path: "/about/:id",
    element: <TeamDetail />
  },
  {
    path: "/blog",
    element: <BlogPage />
  },
  {
    path: "/blog/:shortName",
    element: <BlogPostPage />
  },
  {
    path: "*",
    element: <NotFoundPage />
  }
]; 